// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3BPfv","inputWrap":"styles_inputWrap__2n-mJ","input":"styles_input__3jbqg"};